import Layout from 'components/Layout/Default'
import Link from 'next/link'
import { transformarParaUrlAmigavel } from 'pages/comprar-grama/index.page'
import { useGrass } from 'services/grass'
import { useList } from 'services/tips'
import estadosCidades from 'utils/estados-cidades'

import * as S from './styles'

const SiteMap = () => {
  const { data: grasses } = useGrass()
  const { data: tips } = useList()
  return (
    <Layout
      category={`Mapa do site | Central da Grama`}
      categorySize="25px"
      title="Mapa do site"
      description="Navegue mais facilmente em todas as páginas do site, como por exemplo selecionando diretamente a cidade que deseja seu orçamento."
    >
      <S.WrapLink>
        <Link href="/">
          <a title="Página Inicial">Página Inicial</a>
        </Link>
        <Link href="/fotos">
          <a title="Fotos">Fotos</a>
        </Link>
        <Link href="/contato">
          <a title="Contato">Contato</a>
        </Link>
        <Link href="/#gramas">
          <a title="Gramas">Gramas</a>
        </Link>
        <ul>
          {grasses?.map((item: any) => (
            <li key={item.id}>
              <Link href={`/${item?.slug}`}>
                <a title={item?.title?.rendered}>{item?.title?.rendered}</a>
              </Link>
            </li>
          ))}
        </ul>
        <Link href="/dicas">
          <a title="Dicas">Dicas</a>
        </Link>
        <ul>
          {tips?.map((item: any) => (
            <li key={item.id} >
              <Link href={`/dicas/${item?.slug}`} >
                <a title={item?.title?.rendered} >{item?.title?.rendered}</a>
              </Link>
            </li>
          ))}
        </ul>
        <Link href="/comprar-grama">
          <a title="Comprar Grama">Comprar Grama</a>
        </Link>
        {estadosCidades.map((state) => (
          <ul key={state.sigla}>
            <li>
              <Link
                href={`/comprar-grama/${state?.sigla?.toLocaleLowerCase()}`}
              >
                <a title={`comprar grama ${state.nome}`}>{state.nome}</a>
              </Link>
            </li>
            <li>
              <ul>
                {state.cidades.map((city) => (
                  <li key={city}>
                    <Link
                      href={`/comprar-grama/${state?.sigla?.toLocaleLowerCase()}/${transformarParaUrlAmigavel(
                        city
                      )}`}
                    >
                      <a title={`Comprar grama ${city} ${state?.sigla}`}>{city}</a>
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        ))}
      </S.WrapLink>
    </Layout>
  )
}

export default SiteMap
